

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;




//////////////////
// WEBPACK FOOTER
// ../node_modules/gopd/gOPD.js
// module id = ../node_modules/gopd/gOPD.js
// module chunks = 0